import vuetify from "@/application/plugins/vuetify";
import router from "@/router";
import i18n from "@/application/plugins/i18n";
import pinia from "@/application/plugins/pinia";

import type { App } from "vue";

export function registerPlugins(app: App) {
  app.use(vuetify).use(router).use(pinia).use(i18n);
}
